module.exports = __webpack_public_path__ + "static/media/oln.d1e6eb02.jpg";